import { makeStyles } from "@mui/styles";

const teamMemberStyle = makeStyles((theme) => ({
    teamMember: {
        textAlign: "center",
        [theme.breakpoints.down("sm")]: {
          marginBottom: "2rem",
        }
    },
    avatar: {
        width: "146px !important",
        height: "146px !important",
        margin: "0 auto 2.5rem",
        boxShadow: "0px 8px 15px rgba(0, 0, 0, 0.2)",
        [theme.breakpoints.down("sm")]: {
            width: "170px !important",
            height: "170px !important",
        }
    },
    name: {
        fontWeight: "bold !important",
        color: theme.palette.text.primary,
        [theme.breakpoints.down("sm")]: {
            fontSize: "1.5rem",
        },
    },
    role: {
        marginTop: "0.6rem !important",
        marginBottom: "0.6rem !important",
        color: theme.palette.text.third,
        [theme.breakpoints.down("sm")]: {
            fontSize: "1.3rem !important",
        },
    },
    description: {
        fontSize: '0.81rem !important',
        color: theme.palette.text.fourth,
        [theme.breakpoints.down("sm")]: {
            fontSize: "1.1rem !important",
        },
    },
    socialIcons: {
        display: "flex",
        justifyContent: "center",
        marginTop: "2.6rem !important",
        gap: "0.5rem",
        [theme.breakpoints.down("lg")]: {
            marginTop: "1.3rem !important",
        },
        [theme.breakpoints.down("sm")]: {
            marginTop: "1rem !important",
        },
    },
    icon: {
        color: theme.palette.primary.main,
        "&:hover": {
             color: theme.palette.secondary.main,
        },
        [theme.breakpoints.down("sm")]: {
            "& svg": {
                fontSize: "2rem !important",
              },
        },
    },
    mobileCarouselContainer: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        width: "100%",
        maxWidth: "400px",
        margin: "0 auto",
    },
    cardWrapper: {
        display: "flex",
        justifyContent: "center",
        flexGrow: 1,
        maxWidth: "100%",
    },
    navWrapper: {
        width: "50px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    navButton: {
        position: "absolute",
        top: "50%",
        transform: "translateY(-50%)",
        backgroundColor: "#ffffff",
        color: "#000",
        zIndex: 10,
        "&:hover": {
          backgroundColor: "#f0f0f0",
        },
        "& svg": {
            fontSize: "2rem !important",
        },
    },
    leftNav: {
        left: "10px",
    },
    rightNav: {
        right: "10px",
    },
    navPlaceholder: {
        width: "40px",
        height: "40px",
        visibility: "hidden",
    },
}));

export default teamMemberStyle;